import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Button, TextInputField } from "../../../helpers";
import ViewAdjustmentNote from "../../../common/ViewAdjustmentNote";

import "../index.css"

import { numberConversion } from "../../../utils";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const SellerPOSummary = (props) => {
    const { sellerPO, sellerPOPaymentDetails, sellerPIPunchItems, materialDetails, sellerDebitNotes, sellerDebitNoteItems } = props

    const [visibleViewAdjustmentNote, setVisibleViewAdjustmentNote] = useState(false)

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const totalTDSAmount = sellerPOPaymentDetails?.VPWiseSellerPOPaymentDetails?.totalTDSAmount ? sellerPOPaymentDetails?.VPWiseSellerPOPaymentDetails?.totalTDSAmount : 0

    const navigate = useNavigate()

    return (
        <div className="p-card">
            <div className="grid col-12 flex-column md:flex-row md:p-0 pb-0 px-0">
                <div className="col-12 md:col-6 flex flex-column md:flex-row pr-0 pb-0 md:pt-0 md:pl-2">
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField labelText="Price Before Tax" value={numberConversion(sellerPO?.totalItemAmountBeforeTax, numberLocale)} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField labelText="Total Tax" value={numberConversion(sellerPO?.totalPOTax, numberLocale)} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField labelText="Total Price" value={numberConversion(sellerPO?.totalItemAmountWithTax, numberLocale)} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField labelText="Amount Due" value={numberConversion(sellerPO?.totalItemAmountWithTax, numberLocale)} disabled />
                    </div>
                </div>
                <div className="md:col-6 col-12 flex flex-column md:flex-row md:pl-0 pl-2 pt-0 md:pt-0 pr-0">
                    <div className="flex flex-column col-12 md:col-3 pr-0 pl-2">
                        <TextInputField labelText="Amount Paid" value={0} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField labelText="TDS" value={totalTDSAmount} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-3 pr-0">
                        <TextInputField name="bankName" labelText="TCS" disabled />
                    </div>
                    <div className="flex flex-row col-12 md:col-3 align-items-center mt-2 justify-content-end">
                        { sellerDebitNotes.length > 0 && <Button className="debit-note-btn mr-1" label="DN" rounded onClick={() => {setVisibleViewAdjustmentNote(true)}} /> }
                        <Button severity="success" rounded onClick={() => navigate(`/sellerpo/${sellerPO.sellerPOId}`)} ><i className="pi pi-eye" style={{ fontSize: "1.2rem" }} /></Button>
                    </div>
                </div>
            </div>

            <ViewAdjustmentNote 
                type="Debit Note" 
                adjustmentNote={sellerDebitNotes} 
                adjustmentNoteItems={sellerDebitNoteItems} 
                materialDetails={materialDetails} 
                sellerPIPunchItems={sellerPIPunchItems} 
                visibleViewAdjustmentNote={visibleViewAdjustmentNote} 
                setVisibleViewAdjustmentNote={setVisibleViewAdjustmentNote}
            />
        </div>
    )
}

export default SellerPOSummary;